import { createAction } from '@reduxjs/toolkit'
import { createPromiseAction } from 'redux-saga-promise-actions'

export const getPickupQueue = createAction('queues/GET_PICKUP')
export const getPickupQueueSuccessful = createAction(
  'queues/GET_PICKUP_SUCESSFULL'
)
export const getPickupQueueFailure = createAction('queues/GET_PICKUP_FAILURE')

export const editPickupQueueRSPA = createPromiseAction(
  'rspa: EDIT_PICKUP_QUEUE'
)()

export const deletePickupQueueRSPA = createPromiseAction(
  'rspa: DELETE_PICKUP_QUEUE'
)()

export const clearPickupQueues = createAction('queues/CLEAR_PICKUP_QUEUES')

export const getQueuesCounterRSPA = createPromiseAction(
  'rspa: GET_QUEUES_COUNTER'
)()
export const createPickupQueueRSPA = createPromiseAction('rspa: CREATE_QUEUE')()
